import {
  Box,
  Flex,
  Heading,
  Icon,
  Image,
  Stack,
  Text,
  useTheme,
  useToast
} from '@homebotapp/hb-react-component-catalog'
import { useEffect, useMemo, useState } from 'react'
import { AppLayout } from '../../App/Layout/AppLayout'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveNavigationTab } from '../../store/slices/navigation'
import { NAVIGATION_TAB_NAMES } from '../../types/navigation'
import { ListingGalleryTile } from '../../Components/homeSearch/ListingGalleryTile/ListingGalleryTile'
import isEmpty from 'lodash/isEmpty'
import openDoor from '../../assets/homes/img/openDoor.svg'
import recentPriceDrop from '../../assets/homes/img/priceDrop.svg'
import recentlySold from '../../assets/homes/img/recentlySold.svg'
import { defineMessages, useIntl } from 'react-intl'
import history from '../../history'
import { GoogleAutoComplete } from '../../Components/homeSearch/GoogleAutoComplete/GoogleAutoComplete'
import { useRecoilState } from 'recoil'
import {
  CurrentSelectedLocation,
  currentSelectedLocation
} from '../../Components/homeSearch/GoogleAutoComplete/state/currentSelectedLocation'
import { useGetUserFeeds } from '../../hooks/gallery/useGetUserFeeds'
import { ClientEventName, ClientEventSource, FeedBase, FeedType } from '../../api/gqlaxy/gql/generated/graphql'
import { Feed } from '../../Components/homeSearch/Feed/Feed'
import { RootState } from '../../types/rootState'
import {
  selectCustomerBuyersEnabled,
  selectHomebotListingsFeatureEnabled,
  selectNativeAccessFeature
} from '../../store/selectors/customerProfile'
import useViewport from '../../hooks/useViewport'
import { DownloadMobileAppPromptCard } from '../../Components/homeSearch/ListingDetails/DownloadMobileAppPromptCard/Desktop/DownloadMobileAppPromptCard'
import { MobileDownloadMobileAppPromptCard } from '../../Components/homeSearch/ListingDetails/DownloadMobileAppPromptCard/Mobile/MobileDownloadMobileAppPromptCard'
import { HomeSearchFooter } from '../../Components/homeSearch/HomeSearchFooter/HomeSearchFooter'
import {
  selectClientFirstHome,
  selectClientHomes,
  selectClientIsBuyer,
  selectClientIsLoadingData
} from '../../store/selectors/client'
import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService'
import { useTrackingContext } from '../../providers/tracking'
import { hasCustomerToken, isAuthTokenSupported } from '../../auth'
import { fetchProfile } from '../../actions/customerProfile'
import { fetchClientData, fetchClientHomes, setCurrentClient } from '../../actions/client'
import { addToast } from '../../actions/toasts'
import { NoPreviewModeModal } from '../../Components/NoPreviewModeModal/NoPreviewModeModal'
import { MarketRecordZipCode } from '../../types/marketRecords'
import { fetchBuyerInfoData } from '../../actions'
import { selectMarketInterestZipcodes } from '../../store/selectors/buyerInfo'
import { fetchMarketRecordsDetail } from '../../actions/marketRecords'
import { getBuyerInfoData } from '../../api/mikasa/requests'
import { Redirect, useLocation } from 'react-router'
import { PATH_HELPERS, SEARCH_PATH_HELPERS } from '../../constants/navigation'
import { useChangeFeedsLocation } from '../../hooks/gallery/useChangeFeedsLocation'
import topographicalMapDark from '../../assets/homes/img/topo-bg-wide.svg'
import topographicalMapLight from '../../assets/homes/img/topo-bg-light.png'
import { useCreateClientEvent, useEffectOncePerSessionConditionally } from '../../hooks'
import { useCreateClientEventOnView } from '../../hooks/useCreateClientEventOnView'
import { useGetClientId } from '../../hooks/useGetClientId'
import { INITIALIZE_ROUTE, selectMarketExploreRoute } from '../../store/selectors/routes'
import { selectShouldRenderBuyerOnboarding } from '../../store/selectors/display'
import { camelizeKeys } from '../../helpers/utils'
import qs from 'qs'
import { BuyerOnboarding } from '../buyers/Routes/BuyerOnboarding/BuyerOnboarding'
import { PrequalConfirmationModal } from '../../Components/shared/PrequalConfirmationModal/PrequalConfirmationModal'
import { selectClientShouldSeeMarketsAndBuyerNavButtons } from '../../store/selectors/navigation'
import { useOpeningVideo } from '../../hooks/useOpeningVideo'
import { trackVideoMailerView } from '../../actions/trackingSource'
import { BombBomb } from '../../App/BombBomb/BombBomb'
import OpeningVideo from '../../Components/shared/OpeningVideo/OpeningVideo'
import { selectBombBombIsEnabled } from '../../store/slices/bombBomb'
import { BudgetModal } from './components/BudgetModal'

interface Tile {
  icon: JSX.Element
  label: string
  type?: string
  onClick?: () => void
}

export const MSG = defineMessages({
  for: {
    id: 'Gallery.for',
    defaultMessage: 'For'
  },
  concessions: {
    id: 'Gallery.concessions',
    defaultMessage: 'Seller Concessions'
  },
  concessionsDescription: {
    id: 'ForYouContent.concessionsDescription',
    defaultMessage: 'Sellers cover part of your expenses'
  },
  recentPriceDrop: {
    id: 'Gallery.recentPriceDrop',
    defaultMessage: 'Price Drops'
  },
  recentPriceDropDescription: {
    id: 'Gallery.recentPriceDropDescription',
    defaultMessage: 'See places with a reduced asking price'
  },
  assumables: {
    id: 'Gallery.assumables',
    defaultMessage: 'Assumable Loans'
  },
  assumablesDescription: {
    id: 'Gallery.assumablesDescription',
    defaultMessage:
      "Ask your lender if you qualify for an assumable mortgage. You may be able to save by taking over the seller's low-rate loan!"
  },
  openHouses: {
    id: 'Gallery.openHouses',
    defaultMessage: 'Open Houses'
  },
  openHousesDescription: {
    id: 'Gallery.openHousesDescription',
    defaultMessage: 'See homes in person'
  },
  savedSearches: {
    id: 'Gallery.savedSearches',
    defaultMessage: 'Saved Searches'
  },
  favorites: {
    id: 'Gallery.favorites',
    defaultMessage: 'Favorites'
  },
  yourMarkets: {
    id: 'Gallery.yourMarkets',
    defaultMessage: 'Your Markets'
  },
  yourGalleries: {
    id: 'Gallery.yourGalleries',
    defaultMessage: 'Your Galleries'
  },
  newlyListed: {
    id: 'Gallery.newlyListed',
    defaultMessage: 'Newly Listed'
  },
  newlyListedDescription: {
    id: 'Gallery.newlyListedDescription',
    defaultMessage: 'Be the first to check out these homes as soon as they hit the market!'
  },
  recentlySold: {
    id: 'Gallery.recentlySold',
    defaultMessage: 'Recently Sold'
  },
  recentlySoldDescription: {
    id: 'ForYouContent.recentlySoldDescription',
    defaultMessage: 'Explore to see what the market is like'
  },
  localGallery: {
    id: 'Gallery.localGallery',
    defaultMessage: 'Local Gallery'
  },
  forYou: {
    id: 'Gallery.forYou',
    defaultMessage: 'For You'
  },
  help: {
    id: 'ForYouContent.help',
    defaultMessage: "Let's find your next home"
  },
  localGalleries: {
    id: 'Gallery.localGalleries',
    defaultMessage: 'Local Galleries'
  },
  changeLocation: {
    id: 'Gallery.changeLocation',
    defaultMessage: 'Change Location'
  },
  failedChangeLocation: {
    id: 'Gallery.failedChangeLocation',
    defaultMessage: 'Failed to change feed location'
  },
  errorCreatingFeeds: {
    id: 'Gallery.errorCreatingFeeds',
    defaultMessage: 'Error creating feeds'
  }
})

const LocalGalleryIcon = {
  recentPriceDrop: recentPriceDrop,
  recentlySold: recentlySold,
  assumables: recentPriceDrop,
  concessions: recentPriceDrop,
  openHouses: openDoor,
  newlyListed: recentlySold
}

export const ForYouContent = ({ match }) => {
  const queryParams = camelizeKeys(
    qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    })
  )
  const intl = useIntl()
  const toast = useToast()
  const { theme } = useTheme()
  const dispatch = useDispatch()
  const location = useLocation()
  const { isMediumOrAbove } = useViewport()
  const isImpersonating = hasCustomerToken()
  const { customerProfileId } = match.params
  const homes = useSelector(selectClientHomes)
  const { trackingClient } = useTrackingContext()
  const home = useSelector(selectClientFirstHome)
  const clientZipcodes = useSelector(selectMarketInterestZipcodes)
  const clientId = useGetClientId()
  const [loadingMarketInterests, setLoadingMarketInterests] = useState(true)
  const [showGooglePlaceSelector, setShowGooglePlaceSelector] = useState(false)
  const hasNativeAccess = useSelector<RootState, boolean>(selectNativeAccessFeature)
  const [favoriteMarkets, setFavoriteMarkets] = useState([] as MarketRecordZipCode[])
  const [currentLocation, setCurrentLocation] = useRecoilState(currentSelectedLocation)
  const { mutateAsync: changeFeedsLocation, isLoading: changingFeedsLocation } = useChangeFeedsLocation()
  const marketsRoute = useSelector(selectMarketExploreRoute)
  const shouldRenderNewOnboarding = useSelector(selectShouldRenderBuyerOnboarding)
  const isBuyer = useSelector(selectClientIsBuyer)
  const isLoadingClientData = useSelector(selectClientIsLoadingData)
  const searchEnabled = useSelector(selectHomebotListingsFeatureEnabled)
  const [showPrequalModal, setShowPrequalModal] = useState(queryParams.openPrequalModal === 'true')
  const clientCanAccessBuyerAndMarkets = useSelector(selectClientShouldSeeMarketsAndBuyerNavButtons)
  const customerBuyersEnabled = useSelector(selectCustomerBuyersEnabled)

  // video
  const bombBombIsEnabled = useSelector(selectBombBombIsEnabled)
  const { displayEmailVideo, videoType: videoSource, videoId, audience: audienceType } = useOpeningVideo()
  const [tracked, setTracked] = useState<string[]>([])
  const shouldTrackVideoView = Boolean(displayEmailVideo && !isLoadingClientData && !tracked.includes(videoId))
  const { mutateAsync: createViewedVideoEmailClientEvent } = useCreateClientEvent({ disableErrorPrompts: true })
  const displayOpeningVideo = displayEmailVideo

  if (shouldTrackVideoView) {
    const eventProperties = {
      audienceType,
      videoId,
      videoSource
    }

    dispatch(trackVideoMailerView(eventProperties, createViewedVideoEmailClientEvent))
    setTracked([...tracked, videoId])
  }

  const createViewClientEvent = useCreateClientEventOnView({
    eventName: ClientEventName.View,
    eventSource: ClientEventSource.ForYou
  })
  createViewClientEvent()

  const [showNotAuthorizedModal, setShowNotAuthorizedModal] = useState(!isAuthTokenSupported())
  const { placePredictions, getPlacePredictions, isPlacePredictionsLoading } = usePlacesService({
    apiKey: process.env.REACT_APP_GOOGLE_KEY
  })
  const hasChangeLocationQs = location.search.includes('changeLocation')

  const {
    data,
    isFetching,
    refetch: refreshFeeds
  } = useGetUserFeeds(
    { googlePlaceId: currentLocation?.placeId ?? placePredictions?.[0]?.place_id, webUserId: clientId },
    { enabled: searchEnabled && isAuthTokenSupported() && !!placePredictions?.[0] }
  )

  useEffect(() => {
    if (clientZipcodes) {
      dispatch(fetchMarketRecordsDetail(clientZipcodes))
    }
  }, [clientZipcodes, dispatch])

  const loadMarketInterests = async () => {
    try {
      const response = await getBuyerInfoData(clientId)
      setFavoriteMarkets(response?.data?.data?.marketInterests)
    } catch {
    } finally {
      // Delay finish loading to allow setting the favorite markets
      setTimeout(() => {
        setLoadingMarketInterests(false)
      }, 1000)
    }
  }

  useEffect(() => {
    if (!isAuthTokenSupported()) {
      setLoadingMarketInterests(false)
      return setShowNotAuthorizedModal(true)
    }

    loadMarketInterests()
    dispatch(fetchBuyerInfoData(clientId))
    if (customerProfileId) {
      dispatch(fetchProfile(customerProfileId))
    }
  }, [dispatch, customerProfileId])

  useEffect(() => {
    if (clientId) {
      dispatch(setCurrentClient(clientId))
      dispatch(fetchClientData(clientId, customerProfileId))
      dispatch(fetchClientHomes(clientId))
    }
  }, [dispatch, clientId, customerProfileId])

  // Helper function to determine input and types
  const getInputAndTypes = ({
    favoriteMarkets,
    home,
    homes
  }: {
    favoriteMarkets: MarketRecordZipCode[]
    home: any
    homes: any[]
  }) => {
    if (!isEmpty(favoriteMarkets)) {
      return { input: favoriteMarkets[0].zipcode, types: ['postal_code'] }
    }
    if (home?.address) {
      return { input: `${home.address.street}, ${home.address.zip}` }
    }
    if (homes?.[0]?.address) {
      return { input: homes[0].address.zip, types: ['postal_code'] }
    }
    return { input: 'Denver, CO' }
  }

  useEffect(() => {
    const noPredictions = !placePredictions?.[0]
    const { input, types } = getInputAndTypes({ favoriteMarkets, home, homes })

    if ((!isEmpty(favoriteMarkets) || home || homes) && noPredictions && !loadingMarketInterests) {
      getPlacePredictions({
        input,
        componentRestrictions: { country: 'us' },
        ...(types && { types })
      })
    } else if (
      !isFetching &&
      !isPlacePredictionsLoading &&
      noPredictions &&
      data?.feeds?.length &&
      !loadingMarketInterests
    ) {
      getPlacePredictions({
        input: data.feeds[0]?.location?.name || '',
        componentRestrictions: { country: 'us' }
      })
    }
  }, [
    home,
    data?.feeds,
    favoriteMarkets,
    isFetching,
    isPlacePredictionsLoading,
    placePredictions,
    loadingMarketInterests
  ])

  useEffect(() => {
    if (!isFetching && data?.feeds?.length) {
      // Set the current location to the first feed location
      setCurrentLocation(data?.feeds[0]?.location as unknown as CurrentSelectedLocation)
    }
  }, [data?.feeds, isFetching])

  const galleryTiles = useMemo(() => {
    const tiles = data?.feeds
      ?.filter(feed => MSG[feed?.feedType])
      .map(feed => {
        return {
          icon: (
            <Image
              h={4}
              w={4}
              loading='lazy'
              src={LocalGalleryIcon[feed?.feedType as string]}
              alt={feed?.feedType as string}
            />
          ),
          label: intl.formatMessage(MSG[feed?.feedType as string]),
          type: feed?.feedType,
          onClick: () => {
            trackingClient?.linkInteraction({
              ui_context: 'Gallery_Feed',
              descriptor: `Clicked on Feed ${feed?.feedType}`,
              action: 'Clicked',
              guid: `3GtcZMbe9HLD7YUKKiAyjg_${feed?.feedType}`
            })
            history.push(SEARCH_PATH_HELPERS.gallery.buildPath(customerProfileId, feed?.id, feed?.feedType, clientId))
          }
        }
      }) as Tile[]
    return tiles?.filter((tile, index, self) => self.findIndex(t => t?.type === tile?.type) === index)
  }, [data?.feeds, clientId])

  useEffect(() => {
    dispatch(setActiveNavigationTab(NAVIGATION_TAB_NAMES.FORYOU))
  }, [dispatch])

  const onShowGooglePlaceSelector = () => {
    if (isImpersonating) {
      toast({
        description: 'Changing gallery locations on behalf of your clients is not supported at this time.',
        status: 'warning'
      })
    } else {
      setShowGooglePlaceSelector(true)
    }
  }

  useEffectOncePerSessionConditionally(
    () => {
      onShowGooglePlaceSelector()
      history.push({ search: '' })
    },
    undefined,
    hasChangeLocationQs
  )

  const onLocationChange = async (place: CurrentSelectedLocation) => {
    if (!isAuthTokenSupported()) {
      return
    }
    setCurrentLocation(place)
    setShowGooglePlaceSelector(false)
    if (!data?.feeds) return
    try {
      getPlacePredictions({
        input: place.description,
        componentRestrictions: {
          country: 'us'
        }
      })
      await changeFeedsLocation({
        feedIds: data?.feeds?.map(feed => feed?.id as string),
        googlePlaceId: place.place_id
      })
      refreshFeeds()
    } catch {
      dispatch(
        addToast({
          message: intl.formatMessage(MSG.failedChangeLocation),
          status: 'error'
        })
      )
    }
  }

  const showPageLevelLoader = useMemo(() => {
    return loadingMarketInterests || !currentLocation
  }, [loadingMarketInterests, currentLocation])

  const removeDuplicateRecentlySoldFeeds = (feeds: FeedBase[]) => {
    const firstRecentlySoldIndex = feeds.findIndex(feed => feed.feedType === 'recentlySold')
    if (firstRecentlySoldIndex === -1) return
    const secondRecentlySoldIndex = feeds.findIndex(
      (feed, i) =>
        feed.feedType === 'recentlySold' &&
        i !== firstRecentlySoldIndex &&
        feed.location?.zipCode === feeds[firstRecentlySoldIndex].location?.zipCode
    )
    if (secondRecentlySoldIndex !== -1) {
      feeds.splice(secondRecentlySoldIndex, 1)
    }
  }

  useEffect(() => {
    if (data?.feeds) {
      removeDuplicateRecentlySoldFeeds(data.feeds)
    }
  }, [data?.feeds])

  // this logic was copied from the MarketsTab component
  const buildMarketsRoute = () => {
    if (hasCustomerToken()) {
      const impersonatedClientId: string = localStorage.getItem('impersonatedClientId') || ''
      const impersonatedClientIsBuyer: boolean = localStorage.getItem('impersonatedClientHbbAccess') === 'true'

      const buyRoute =
        impersonatedClientIsBuyer && !!impersonatedClientId
          ? PATH_HELPERS.markets.buildPath(impersonatedClientId, '/explore/map')
          : INITIALIZE_ROUTE
      return buyRoute
    } else {
      return marketsRoute
    }
  }

  if (!isBuyer && !isLoadingClientData && customerBuyersEnabled) {
    return <Redirect to={'/reports/initialize/buy'} />
  }

  return (
    <AppLayout loading={showPageLevelLoader} enableAgentDropdown match={match}>
      {shouldRenderNewOnboarding && queryParams.openPrequalModal !== 'true' && <BuyerOnboarding />}
      {showPrequalModal && (
        <PrequalConfirmationModal onClose={() => setShowPrequalModal(false)} uiContext='For You Page' />
      )}
      {showNotAuthorizedModal && <NoPreviewModeModal />}
      {showGooglePlaceSelector && (
        <GoogleAutoComplete onClose={() => setShowGooglePlaceSelector(false)} onPlaceSelected={onLocationChange} />
      )}
      {bombBombIsEnabled && (
        <Box position='absolute' top='10px' right='10px' zIndex='ceiling'>
          <BombBomb />
        </Box>
      )}
      {displayOpeningVideo && (
        <Box mb='2'>
          <OpeningVideo />
        </Box>
      )}
      <Box
        mt={-2}
        pt={8}
        pb={12}
        px={[5, null, 20]}
        backgroundImage={`url(${theme.isLightThemeType ? topographicalMapLight : topographicalMapDark})`}
        backgroundSize='cover'
        backgroundBlendMode='multiply'
        backgroundColor='whiteAlpha.50'
        _dark={{
          backgroundColor: 'blackAlpha.600'
        }}
      >
        <Flex flexDirection={['column', 'column', 'row']} gap={[2, 4]} justifyContent={'space-between'} flexWrap='wrap'>
          <Box>
            <Flex pb={4} alignItems='center' justifyContent='space-between'>
              <Box>
                <Heading as='h1' size='2xl' textAlign='left' m={0} fontWeight={600} mb={4}>
                  {intl.formatMessage(MSG.forYou)}
                </Heading>
                <Text m={0} size='xs' color='neutral.900'>
                  {intl.formatMessage(MSG.help)}
                </Text>
              </Box>
            </Flex>
            <Stack direction='row' spacing={2} overflowX='auto' flexWrap='nowrap'>
              <Flex flex='0 0 auto' direction='column'>
                <Stack direction='row' spacing={2}>
                  {searchEnabled && (
                    <ListingGalleryTile
                      icon={<Icon name='bookmark-magnifying-glass' color='neutral.700' />}
                      title={intl.formatMessage(MSG.savedSearches)}
                      onClick={() => {
                        trackingClient?.linkInteraction({
                          ui_context: 'Gallery_SavedSearch_Card',
                          descriptor: 'Clicked on Saved Search',
                          action: 'Clicked',
                          guid: '3GtpqMPqaHLD7YUKKiAyjg'
                        })
                        history.push(`/home-search/${customerProfileId}/saved-searches`)
                      }}
                    />
                  )}
                  {searchEnabled && (
                    <ListingGalleryTile
                      icon={<Icon name='heart' color='neutral.700' />}
                      title={intl.formatMessage(MSG.favorites)}
                      onClick={() => {
                        trackingClient?.linkInteraction({
                          ui_context: 'Gallery_Favorites_Card',
                          descriptor: 'Clicked on Favorites',
                          action: 'Clicked',
                          guid: '3GtcZMPqaHLD7YUKKiAyjg'
                        })
                        history.push(SEARCH_PATH_HELPERS.favoriteListings.buildPath(customerProfileId, clientId))
                      }}
                    />
                  )}
                  {clientCanAccessBuyerAndMarkets && (
                    <ListingGalleryTile
                      icon={<Icon name='map-marked-alt-filled' color='neutral.700' />}
                      title={intl.formatMessage(MSG.yourMarkets)}
                      onClick={() => {
                        trackingClient?.linkInteraction({
                          ui_context: 'Gallery_Favorites_Card',
                          descriptor: 'Clicked on Your Markets',
                          action: 'Clicked',
                          guid: '7mbCiLVFgWFgKreJzezdPa'
                        })
                        history.push(buildMarketsRoute())
                      }}
                    />
                  )}
                </Stack>
              </Flex>
            </Stack>
          </Box>
          <Box mt={4} alignSelf={['center', 'center', 'flex-end']} w={['100%', '100%', 'auto']}>
            <BudgetModal />
          </Box>
        </Flex>
      </Box>

      {searchEnabled && (
        <>
          <Box
            // @ts-ignore
            background='linear-gradient(0.25turn, var(--hb-colors-primary-500), var(--hb-colors-text-brand))'
            h='0.0625rem'
            w='100%'
            data-qa='for-you-divider'
          />

          <Box px={[5, null, 20]} mt={8}>
            <Flex justifyContent='space-between' alignItems='center' mb={8} flexDirection={['column', 'column', 'row']}>
              <Heading as='h2' size='xl' textAlign='left' m={0} fontWeight={600} mb={4}>
                {intl.formatMessage(MSG.yourGalleries)}
              </Heading>
              <Box flex={[1, null, 0.3]}>
                <Text color='neutral.900' fontWeight='semibold' textAlign='right' size={['sm', null, 'md']} m={0}>
                  <Icon mr={2} name='map-marker-mdc' />
                  {currentLocation?.name || currentLocation?.description}
                </Text>
                <Text
                  cursor='pointer'
                  onClick={onShowGooglePlaceSelector}
                  textColor='primary.500'
                  float='right'
                  size='xs'
                  m={0}
                >
                  {intl.formatMessage(MSG.changeLocation)}
                </Text>
              </Box>
            </Flex>

            <Stack direction='row' spacing={2} overflowX='auto' flexWrap='nowrap' mb={8}>
              <Flex flex='0 0 auto' direction='column'>
                <Stack direction='row' spacing={2}>
                  {galleryTiles?.map((tile, index) => (
                    <ListingGalleryTile key={index} icon={tile.icon} title={tile.label} onClick={tile.onClick} />
                  ))}
                </Stack>
              </Flex>
            </Stack>

            {data?.feeds?.map(feed => {
              if (!MSG[feed?.feedType]) {
                return null
              }

              return <Feed key={feed?.id} feed={feed as FeedBase} />
            })}
          </Box>
        </>
      )}
      {hasNativeAccess && (
        <Box margin={8}>
          {isMediumOrAbove ? (
            <DownloadMobileAppPromptCard isLandingPage={true} />
          ) : (
            <MobileDownloadMobileAppPromptCard isLandingPage={true} />
          )}
        </Box>
      )}
      <HomeSearchFooter />
    </AppLayout>
  )
}
